/**
 * WordPress dependencies
 */
import { store, getContext, getElement } from '@wordpress/interactivity';

const { state } = store( 'create-block', {
	state: {
		get themeText() {
			return state.isDark ? state.darkText : state.lightText;
		},
		get activeFilter () {
			return (state.category || state.brand)  ? true  : false
		}
	},
	actions: {
		submitFilter () {
			const context = getContext()
			if (context.isChecked) {
				state.categoryFilter = null
				state.category = null
			}else{
				state.category = 'product_category'
				state.categoryFilter = context.id
			}
			console.log(context.id)
			setTimeout(()=>document.querySelector("#product-filter").submit(),20)
		},
		async submitFilter2 () {
			const context = getContext()
			if (context.isChecked) {
				state.brand = null
				state.brandFilter = null
			}else{
				state.brand = 'brand'
				state.brandFilter = context.id
			}
			setTimeout(()=>document.querySelector("#product-filter").submit(), 20)
		},
		slide() {
			state.isFilterActive = !state.isFilterActive
		},
		alert () {
			alert("Hi")
		},
		clearBrandFilter () {
			state.brand = null
			state.brandFilter = null
			state.BrandFilterName = null
			setTimeout(()=>document.querySelector("#product-filter").submit(), 20)
		},
		clearCategoryFilter () {
			state.categoryFilter = null
			state.category = null
			state.CategoryFilterName = null
			setTimeout(()=>document.querySelector("#product-filter").submit(), 20)
		},
		clearAllFilter () {
			state.brand = null;
			state.brandFilter = null;
			state.BrandFilterName = null;
			state.categoryFilter = null;
			state.category = null;
			state.CategoryFilterName = null;
			setTimeout(() => document.querySelector("#product-filter").submit(), 20);
		}
	},
	callbacks: {
		logIsOpen: () => {
			const { isOpen } = getContext();
			// Log the value of `isOpen` each time it changes.
			console.log( `Is open: ${ isOpen }` );
		},
	},
} );
